import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  TextField,
} from '@mui/material';
import Select from 'react-select';

import { quipUserShape } from '../../types';
import { convertToQid } from '../../utilities/stringHelper';

export default class ResetEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEmail: undefined,
      newEmail: undefined,
    };
  }

  getUserWithEmail = (email) => this.props.users.find((user) => user.email === email);

  getEmails = () => this.props.users.map(
    (user) => (
      {
        value: user.email,
        label: `${user.surname}, ${user.firstname}(${user.email}) ${convertToQid(user.id, (user.institute?.country || user.userCountry))}`,
      }
    ),
  );

  render() {
    return (
      <div>
        <Select
          options={this.getEmails()}
          onChange={(selection) => this.setState({ selectedEmail: selection.value })}
        />
        <TextField
          sx={{ width: '100%' }}
          label={<FormattedMessage id="admindetails.resetEmailNewEmailHint" />}
          onChange={(e) => this.setState({ newEmail: e.target.value })}
          value={this.state.newEmail || ''}
          variant="standard"
        />
        <Button
          variant="contained"
          color="primary"
          sx={{ my: 2 }}
          onClick={async () => {
            await this.props.onResetEmail(
              this.getUserWithEmail(this.state.selectedEmail),
              this.state.newEmail,
            );
            this.setState({
              selectedEmail: undefined,
              newEmail: undefined,
            });
          }}
          disabled={!this.state.selectedEmail || !this.state.newEmail}
        >
          <FormattedMessage id="admindetails.resetEmailButton" />
        </Button>
      </div>
    );
  }
}

ResetEmail.propTypes = {
  users: PropTypes.arrayOf(quipUserShape).isRequired,
  onResetEmail: PropTypes.func.isRequired,
};
